export const COLORS = {
    primary: {
      persianIndigo: '#200865',
      darkPersianIndigo: '#150849',
      violet: '#713FFF',
      darkViolet: '#562EED',
      softLime: '#AFE7AF',
      deepSoftLime: '#8CE58C',
    },
    extended: {
      orange: '#FF5E2E',
      blue: '#0E45FB',
      unbleachedSilk: '#FCDAC8',
      cultured: '#F2F5F9',
      lavenderBlue: '#CFBEFF',
      grayishLime: '#DEFADE',
      lightGrayishLime: '#EBFCEB',
      redSalsa: '#FF193B',
      magnolia: '#F8F5FF',
      azure: '#0E81FF',
    },
    admin: {
      // Admin theme color - Azure
      primary: '#0E81FF',
      // Admin theme variations
      primaryHover: '#0D6EE6',
      primaryLight: '#E8F4FF',
      primaryDark: '#0B6ACC',
    },
    user: {
      // User dashboard main theme color - Azure (same as admin)
      primary: '#0E81FF',
      // User dashboard variations
      primaryHover: '#0D6EE6',
      primaryLight: '#E8F4FF',
      primaryDark: '#0B6ACC',
      // Query button and interactive elements color
      queryButton: '#0E45FB',
      queryButtonHover: '#0D3EE6',
      queryButtonLight: '#E8F0FF',
    }
  };